import { handleAppError } from "@main/infra/handle-app-error";

/**
 * §5.8.4: leaf の網漏れ (カバーしていない非同期や Promise 漏れ) の最終キャッチ。
 * 起動時に 1 回だけ window の error / unhandledrejection を購読する。
 *
 * AppError かどうかは handleAppError 内で判定する。
 */
export function installGlobalErrorHandler(): void {
  window.addEventListener("error", (event) => {
    // ErrorEvent.error が無い古い経路でも message を Error にラップして渡し、
    // handleAppError 側の isAppError / Error 前提を崩さない。
    const err = event.error ?? new Error(event.message || "uncaught error");
    handleAppError(err);
  });

  window.addEventListener("unhandledrejection", (event) => {
    handleAppError(event.reason);
  });
}
